import {Container, List, ListItem, Text} from '@chakra-ui/react';
import {TitledSection} from 'components/layouts/aside-layout/components';
import {Checkbox} from 'components/shared';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {TranslationKeys} from 'translations';

interface IProps {
  payment_for_self: boolean;
  onChange: (value: boolean) => void;
  t: (term: TranslationKeys) => string;
}

const list = [
  {
    title: {
      en: 'Yes',
      ru: 'Да',
      ro: 'Da',
    },
    value: true,
  },
  {
    title: {
      en: 'No',
      ru: 'Нет',
      ro: 'Nu',
    },
    value: false,
  },
];

export const PaymentForSelf: FC<IProps> = ({payment_for_self, onChange, t}) => {
  const {locale} = useRouter();

  return (
    <TitledSection title={t('ORDER_FOR_SELF_TITLE')}>
      <Container display="flex" alignItems="center" variant="white-block">
        <List>
          {list.map((item, index) => {
            const lang = locale as 'en' | 'ru' | 'ro';
            const currentLocale = item.title[lang];

            return (
              <ListItem
                key={index}
                position="relative"
                sx={{
                  _notLast: {
                    pb: '10px',
                  },
                  _last: {
                    pt: '10px',
                  },
                }}
              >
                <Checkbox
                  variant="circle"
                  alignItems="flex-start"
                  isChecked={item.value === payment_for_self}
                  // isDisabled={item.disabled}
                  onChange={() => onChange(item.value)}
                >
                  <Text>{currentLocale}</Text>
                </Checkbox>
              </ListItem>
            );
          })}
        </List>
      </Container>
    </TitledSection>
  );
};
